/*
BaseURL.js
请求前段
 */

import axios from 'axios';

const BaseURL = axios.create(
    {
        // 正式域名：https://point5.cn/
        baseURL: 'https://point5.cn/',
        // baseURL: 'http://127.0.0.1:8001/',
        headers: {
            'Content-Type': 'application/json',
        },
        withCredentials: true,
    }
);

export default BaseURL;